// extracted by mini-css-extract-plugin
export var title = "jx8ij8t6";
export var shortlistContainer = "hvBmFm3p";
export var choiceRank = "_9YKajHrh";
export var dragBackground = "uMjIu9z-";